module.exports = __webpack_public_path__ + "img/phone-call.2f56f637.png";